require('./src/ui-layout');
module.exports = 'ui.layout';

